import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { combineLatest, filter } from 'rxjs';
import { AppState } from '../../../store/state';
import { isPresent } from '../../../utils/isPresent';
import {
  selectDocumentGenerationResponse,
  selectGeneratingDocument,
} from 'src/app/modules/document-generation/store/selectors';
import { GenerateDocumentResponse } from 'src/app/modules/document-generation/services/document-generation-api.service';

@UntilDestroy()
@Component({
  selector: 'app-doc-generation-notification',
  templateUrl: './doc-generation-notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocGenerationNotificationComponent implements OnInit {
  public generatingDocument: boolean = false;
  public generateDocumentResponse: GenerateDocumentResponse | null = null;

  constructor(
    private store$: Store<AppState>,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.store$.select(selectGeneratingDocument).pipe(filter(isPresent)),
      this.store$.select(selectDocumentGenerationResponse),
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([generating, generateDocumentResponse]) => {
        this.generatingDocument = generating;
        this.generateDocumentResponse = generateDocumentResponse;
        this.cdr.markForCheck();
      });
  }

  get docName(): string {
    return this.generateDocumentResponse?.documentName || '';
  }
}
